import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Card } from '@atlaskit/smart-card';
import { CardSSR } from '@atlaskit/smart-card/ssr';
import { UnsupportedInline } from '@atlaskit/editor-common/ui';
import { fg } from '@atlaskit/platform-feature-flags';
import { CardErrorBoundary } from './fallback';
import { withSmartCardStorage } from '../../ui/SmartCardStorage';
import { getCardClickHandler } from '../utils/getCardClickHandler';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { useInlineAnnotationProps } from '../../ui/annotations/element/useInlineAnnotationProps';
var InlineCard = function InlineCard(props) {
  var url = props.url,
    data = props.data,
    eventHandlers = props.eventHandlers,
    portal = props.portal,
    smartLinks = props.smartLinks;
  var onClick = getCardClickHandler(eventHandlers, url);
  var cardProps = {
    url: url,
    data: data,
    onClick: onClick,
    container: portal
  };
  var _ref = smartLinks || {},
    showAuthTooltip = _ref.showAuthTooltip,
    hideHoverPreview = _ref.hideHoverPreview,
    actionOptions = _ref.actionOptions,
    ssr = _ref.ssr;
  var analyticsData = {
    attributes: {
      location: 'renderer'
    },
    // Below is added for the future implementation of Linking Platform namespaced analytic context
    location: 'renderer'
  };
  var inlineAnnotationProps = useInlineAnnotationProps(props);
  if (ssr && url) {
    if (
    // eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
    fg('editor_inline_comments_on_inline_nodes')) {
      return jsx("span", _extends({
        "data-inline-card": true,
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url
      }, inlineAnnotationProps), jsx(AnalyticsContext, {
        data: analyticsData
      }, jsx(CardSSR, {
        appearance: "inline",
        url: url,
        showAuthTooltip: showAuthTooltip,
        showHoverPreview: !hideHoverPreview,
        actionOptions: actionOptions,
        onClick: onClick
      })));
    }
    return jsx(AnalyticsContext, {
      data: analyticsData
    }, jsx(CardSSR, {
      appearance: "inline",
      url: url,
      showAuthTooltip: showAuthTooltip,
      showHoverPreview: !hideHoverPreview,
      actionOptions: actionOptions,
      onClick: onClick
    }));
  }
  var onError = function onError(_ref2) {
    var err = _ref2.err;
    if (err) {
      throw err;
    }
  };
  return jsx(AnalyticsContext, {
    data: analyticsData
  }, jsx("span", _extends({
    "data-inline-card": true,
    "data-card-data": data ? JSON.stringify(data) : undefined,
    "data-card-url": url
  }, inlineAnnotationProps), jsx(CardErrorBoundary, _extends({
    unsupportedComponent: UnsupportedInline
  }, cardProps), jsx(Card, _extends({
    appearance: "inline",
    showHoverPreview: !hideHoverPreview,
    showAuthTooltip: showAuthTooltip,
    actionOptions: actionOptions
  }, cardProps, {
    onResolve: function onResolve(data) {
      if (!data.url || !data.title) {
        return;
      }
      props.smartCardStorage.set(data.url, data.title);
    },
    onError: onError
  })))));
};
export default withSmartCardStorage(InlineCard);